module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-08-1dff2dc7.svg";